module.exports = __webpack_public_path__ + "img/arrows-alt-h.65e35118.svg";